/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type TranslatableEntity = 'SubscriptionPlan' | 'Promotion' | 'Report' | 'UserFeedback' | 'Penalty' | 'Convention' | 'ConventionForm' | 'Organization' | 'Ente' | 'PushNotification' | 'Zone' | 'City' | 'Hub' | 'OperationalArea' | 'Model' | 'News';

export const TranslatableEntity = {
    SubscriptionPlan: 'SubscriptionPlan' as TranslatableEntity,
    Promotion: 'Promotion' as TranslatableEntity,
    Report: 'Report' as TranslatableEntity,
    UserFeedback: 'UserFeedback' as TranslatableEntity,
    Penalty: 'Penalty' as TranslatableEntity,
    Convention: 'Convention' as TranslatableEntity,
    ConventionForm: 'ConventionForm' as TranslatableEntity,
    Organization: 'Organization' as TranslatableEntity,
    Ente: 'Ente' as TranslatableEntity,
    PushNotification: 'PushNotification' as TranslatableEntity,
    Zone: 'Zone' as TranslatableEntity,
    City: 'City' as TranslatableEntity,
    Hub: 'Hub' as TranslatableEntity,
    OperationalArea: 'OperationalArea' as TranslatableEntity,
    Model: 'Model' as TranslatableEntity,
    News: 'News' as TranslatableEntity
};